import React, { Fragment, useState } from 'react';
import CustomModal from '../../../../../Components/CustomModal/CustomModal';

import getDate from '../../../../../Helpers/Date/GetDate';
import PurchaseOrderDetails from '../../../PurchaseOrderDetails';
import { PurchaseOrderIcon } from '../../../../../Assets/Navigation/NavigationIcons';

export default ({ bill, currency, history, inModal, t }) => {
  const {
    order_no: purchaseOrderNo,
    bill_date: billDate,
    due_date: dueDate,
    total,
    balance_due: balanceDue,
    // vendor: { display_name, id: vendorId },
    bill_created_by: { name: createdBy },
    purchase_orders = [],
  } = bill;
  const [showPOModal, setShowPOModal] = useState(false);

  function viewPurchaseOrderModal() {
    return (
      <CustomModal
        showModal={showPOModal}
        title={t('common.view_purchase_order')}
        className="popup-height purchase-order--popup"
        renderActions={false}
        size="large"
        Icon={PurchaseOrderIcon}
        linkTo={`purchaseorders/${purchase_orders[0]?.id}`}
        onClose={() => setShowPOModal(false)}
      >
        <PurchaseOrderDetails id={purchase_orders[0]?.id} inModal={true} />
      </CustomModal>
    );
  }

  return (
    <>
      {viewPurchaseOrderModal()}
      <div className="section-details--info position-relative mb_30">
        {purchaseOrderNo && (
          <Fragment>
            <div className="details_row">
              <div className="section-details--info-title semi-bold">
                {t('common.order_no')}{' '}
              </div>
              {inModal ? (
                <div>{purchaseOrderNo}</div>
              ) : (
                <div
                  className={
                    purchase_orders.length
                      ? 'text_underline pointer'
                      : 'text_underline'
                  }
                  onClick={() => purchase_orders.length && setShowPOModal(true)}
                >
                  {purchaseOrderNo}
                </div>
              )}
            </div>
          </Fragment>
        )}
        <Fragment>
          <div className="details_row">
            <div className="section-details--info-title semi-bold margin-top-sm">
              {t('bill.bill_date')}
            </div>
            <div>{getDate(billDate)}</div>{' '}
          </div>
        </Fragment>
        <Fragment>
          <div className="details_row">
            <div className="section-details--info-title semi-bold margin-top-sm">
              {t('bill.due_date')}
            </div>
            <div>{getDate(dueDate)}</div>{' '}
          </div>
        </Fragment>
        <Fragment>
          <div className="details_row">
            <div className="section-details--info-title semi-bold margin-top-sm">
              {t('bill.created_by')}
            </div>
            <div className="text-right -user--name">{createdBy}</div>
          </div>
        </Fragment>
        <Fragment>
          <div className="details_row">
            <div className="section-details--info-title semi-bold margin-top-sm">
              {t('bill.total')}
            </div>
            <div>
              {currency.symbol}
              {parseFloat(total).toFixed(2)}
            </div>{' '}
          </div>
        </Fragment>

        <Fragment>
          <div className="details_row">
            <div className="section-details--info-title semi-bold margin-top-sm">
              {t('bill.balance_due')}
            </div>
            <div className="semi-bold-amount">
              {currency.symbol}
              {parseFloat(balanceDue).toFixed(2)}
            </div>
          </div>
        </Fragment>
      </div>
    </>
  );
};
